import { Group, GroupMemberCount, GroupMemberCounts, YammerState } from '../../state/types';
import { createFindRecordByIdThrows } from '../findRecordById';

const findByIdThrows = createFindRecordByIdThrows<GroupMemberCount>('groupMemberCounts');

type GetTotalMemberCountByIdThrows = (state: YammerState, groupId: Group['id']) => GroupMemberCount['totalMemberCount'];

export const getTotalMemberCountByIdThrows: GetTotalMemberCountByIdThrows = (state, groupId) =>
  findByIdThrows(state, groupId).totalMemberCount;

type GetFulfilledGroupMemberCounts = (state: YammerState) => GroupMemberCounts;
export const getFulfilledGroupMemberCounts: GetFulfilledGroupMemberCounts = (state) => state.groupMemberCounts;
